import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
} from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
@Component({
    selector: 'app-modal-component',
    templateUrl: './modal.component.html',
    styleUrls: [],
    animations: modalAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ModalComponent{
    @Input() modalTitle: string;
    @Input() content: string;
    @Input() visibility: boolean;
    @Output() visibilityChange = new EventEmitter<boolean>();
    close() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
    }
}
